/**
 * Converts a hex color to rgb
 *
 * @example hexToRgb('#2e8b57') => { r: 46, g: 139, b: 87 }
 *
 * @param {string} hex The color to transform to rgb
 *
 * @returns {RgbColor} The color in rgb object
 */
export var hexToRgb = function (hex) {
    var rgbArray = hex
        .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (m, r, g, b) { return "#" + r + r + g + g + b + b; })
        .substring(1)
        .match(/.{2}/g)
        .map(function (x) { return parseInt(x, 16); });
    return {
        r: rgbArray[0],
        g: rgbArray[1],
        b: rgbArray[2],
    };
};
